import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { fetchTourById } from "@/redux/slices/tourSlice";
import Contact from "@/components/tour-detail/contact";
import Description from "@/components/tour-detail/description";
import FAQ from "@/components/tour-detail/FAQ";
import Location from "@/components/tour-detail/location";
import Reviews from "@/components/tour-detail/reviews";
import TourDetailImage from "@/components/tour-detail/tour-detail-image";
import TourDetailInfoBooking from "@/components/tour-detail/tour-detail-info-booking";
import TourDetailSummary from "@/components/tour-detail/tour-detail-summary";
import LoadingSpinner from "@/components/loading/LoadingSpinner";
import Layout from "../components/layout/layout";

const TourDetailPage = () => {
  const { tourId } = useParams(); // Lấy ID tour từ URL
  const dispatch = useDispatch();
  const { userInfo } = useSelector((state) => state.user);
  // Lấy dữ liệu tour từ Redux store
  const { selectedTour, loading, error } = useSelector((state) => state.tour);

  useEffect(() => {
    if (tourId) {
      dispatch(fetchTourById(tourId)); // Gọi API để lấy chi tiết tour
    }
  }, [dispatch, tourId]);
  console.log(selectedTour, "selectedTour...");

  // Xử lý trạng thái loading và error
  if (loading)
    return (
      <p>
        <LoadingSpinner
          type="circle"
          color="#3498db"
          size={30}
          text="Đang tải dữ liệu..."
        />
      </p>
    );
  if (error) return <p className="text-danger">Lỗi: {error}</p>;
  if (!selectedTour) return <p>Không tìm thấy thông tin tour.</p>;

  return (
    <Layout>
      <main className="content">
        <div className="container">
          <div className="row">
            <div className="col-xl-8">
              <TourDetailImage selectedTour={selectedTour} />

              <Description selectedTour={selectedTour} />

              <Location selectedTour={selectedTour} />

              <FAQ />

              <Reviews tourId={selectedTour.tourId} />
            </div>

            <div className="col-xl-4 theiaStickySidebar">
              <TourDetailSummary selectedTour={selectedTour} />

              <TourDetailInfoBooking
                selectedTour={selectedTour}
                userInfo={userInfo}
              />

              <Contact />
            </div>
          </div>
        </div>
      </main>
    </Layout>
  );
};

export default TourDetailPage;
